import { useQuery } from 'react-query';
import { QueryKeys } from '../QueryKey';
import axiosInstance from '../axiosConfig';

export function useGetProfessionalRecievedRequests(id: string) {
    const getProfessionalReviewRequests = async (id: string) => {
        const response = await axiosInstance.get(
            `/api/professional-reviews-requests/${id}/received`
        );
        const data = await response.data;
        return data;
    };
    return useQuery(QueryKeys.ProfessionalReviewRequests, () =>
        getProfessionalReviewRequests(id)
    );
}
